import { createSelector } from '@ngrx/store';
import { projectsFeature } from './projects.reducer';

export const {
  selectProjectsState,
  selectProject,
  selectProjectList,
  selectRequestState,
  selectSelectedProjectId,
} = projectsFeature;

export const selectIsProjectIdSet = createSelector(
  selectSelectedProjectId,
  projectId => projectId !== null && projectId !== ''
);
